import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { MuscleGroupService } from 'src/services/muscle-group.service';

@Pipe({
    name: 'isGroup',
    pure: false,
    standalone: false
})
export class IsGroupPipe implements PipeTransform {
  constructor(private muscleGroupService: MuscleGroupService) {}

  transform(value: string): Observable<boolean> {
    if (!value) {
      return new Observable((observer) => observer.next(false)); // Immediately complete with `false` if value is falsy
    }
    return this.muscleGroupService.isGroup(value);
  }
}
